import resourceService from "./resource.service";
import baseService from "./base.service";

const path = 'admin/libraries'
const service = resourceService.init(path)
service.delete = (id) => {
    return baseService.request(axios.delete(`admin/packages/${id}`))
}
service.store = (data) => {
    return baseService.request(axios.post(`admin/packages`, data))
}
service.update = (id, data) => {
    return baseService.request(axios.post(`admin/packages/${id}`, data))
}
service.resize = (id) => {
    return baseService.request(axios.post(`asset/${id}/process`))
}
service.uploadImages = (id, files = [], onProgress) => {
    let url = 'upload/asset/images'
    let form = new FormData()
    for (var index = 0; index < files.length; index++) {
        form.append("images[" + index + "]", files[index])
    }
    form.append('asset_package_id', id)
    return baseService.request(axios.post(url, form, {
        onUploadProgress: (progressEvent) => {
            const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
            console.log("onUploadProgress", totalLength);
            if (totalLength !== null) {
                if(onProgress){
                    onProgress(Math.round((progressEvent.loaded * 100) / totalLength))
                }
            }
        },
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }), true)
}
export default service
